import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Container, Paper, TextField, Typography } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../../Navbar/Navbar";
import BgImage from "../../assets/shipimage.jpg";
import axios from "axios";
import baseURL from "../../config";

const Otp = () => {
  const [otp, setOtp] = useState("");
  const [isResending, setIsResending] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { value } = e.target;
    if (/^\d{0,6}$/.test(value)) {
      setOtp(value);
    }
  };

  const handleVerify = async () => {
    if (otp.length !== 6) {
      toast.error("Enter a valid 6-digit OTP!");
      return;
    }

    const email = localStorage.getItem("userEmail");
    const name = localStorage.getItem("userName");

    try {
     
      const response = await axios.post(`${baseURL}/api/verify`, { email, otp });

      if (response.status === 200) {
        toast.success("OTP Verified Successfully!");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("userName");
        setTimeout(() => navigate("/login"), 2000);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "OTP verification failed.");
      console.error("OTP verification error:", error);
    }
  };

  const handleResendOTP = async () => {
    setIsResending(true);
    const email = localStorage.getItem("userEmail");

    if (!email) {
      toast.error("User email not found. Please sign up again.");
      setIsResending(false);
      return;
    }

    try {
      await axios.post(`${baseURL}/api/resendotp`, { email });
      toast.success("New OTP sent successfully!");
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to resend OTP.");
    }
    setIsResending(false);
  };

  return (
    <>
      <Navbar />
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: `linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3)), url(${BgImage}) center/cover no-repeat`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          pt: 10,
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={10}
            sx={{
              p: 5,
              borderRadius: 5,
              backdropFilter: "blur(15px)",
              bgcolor: "rgba(255, 255, 255, 0.95)",
              textAlign: "center",
              boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)",
            }}
          >
            <Typography variant="h4" fontWeight="bold" color="primary" mb={2}>
              OTP Verification
            </Typography>
            <Typography variant="h6" color="textPrimary" mb={1}>
              Hello, {localStorage.getItem("userName") || "User"}!
            </Typography>
            <Typography variant="body1" color="textSecondary" mb={3}>
              We have sent a verification code to <strong>{localStorage.getItem("userEmail") || "your email"}</strong>.
              Please enter the OTP below to proceed.
            </Typography>
            <TextField
              fullWidth
              label="Enter OTP"
              variant="outlined"
              value={otp}
              onChange={handleChange}
              inputProps={{ maxLength: 6, style: { textAlign: "center", fontSize: "1.5rem", fontWeight: "bold" } }}
              sx={{
                mb: 3,
                width: "100%",
                mx: "auto",
                "& .MuiOutlinedInput-root": {
                  borderRadius: 3,
                  height: "55px",
                  fontSize: "1.5rem",
                },
              }}
            />
            <Button
              variant="contained"
              color="success"
              sx={{ mt: 2, width: "100%", p: 1.8, fontSize: "1.2rem", fontWeight: "bold", borderRadius: 3 }}
              onClick={handleVerify}
            >
              Verify OTP
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              sx={{ mt: 2, width: "100%", p: 1.5, fontSize: "1rem", fontWeight: "bold", borderRadius: 3 }}
              onClick={handleResendOTP}
              disabled={isResending}
            >
              {isResending ? "Resending..." : "Resend OTP"}
            </Button>
          </Paper>
        </Container>
      </Box>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default Otp;